import { Number, Record, Static, String, Boolean } from 'runtypes'

export const Group = Record({
    id: Number,
    title: String,
    level: Number,
    priority: Number,
    isGeneral: Boolean,
    parentClsGroupId: Number.nullable(),
    goodsCount: Number.nullable(),
    imageEndPath: String.nullable()
})

export type IGroup = Static<typeof Group>
